import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { FlexDiagnosticWindow } from 'app/shared/models/flex-diagnostic-window';

@Component({
    selector: 'app-diagnostic-window-popover',
    templateUrl: './diagnostic-window-popover.component.html',
    styleUrls: ['./diagnostic-window-popover.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosticWindowPopoverComponent {
    @Input() public locationName: string;
    @Input() public window: FlexDiagnosticWindow;
    @Input() public nextExpectedDiagnosticSession: Date | null;
    @Input() public customerDateFormat: string;

    @Output() public edit = new EventEmitter<void>();
    @Output() public deleteWindow = new EventEmitter<void>();
    @Output() public closePopover = new EventEmitter<void>();

    constructor(private elementRef: ElementRef<HTMLElement>) {}

    @HostListener('document:keydown.escape')
    public onEscape(): void {
        this.closePopover.emit();
    }

    @HostListener('document:click', ['$event'])
    public onDocumentClick(event: MouseEvent): void {
        const target = event.target;
        if (target instanceof Node && !this.elementRef.nativeElement.contains(target)) {
            this.closePopover.emit();
        }
    }
}
